<template>
    <div>
        <b-table
            show-empty
            empty-text="ไม่มีรายละเอียดข้อมูลอัพโหลดรูปร้าน"
            :items="images"
            :fields="fieldsImages"
            responsive
            :busy="busy"
            class="scroll-bar-pop"
        >
            <div slot="table-busy" class="text-center">
                <BlockUI >
                    <div class="loader"></div>
                </BlockUI>
            </div>
            <template slot="shop_code" slot-scope="row">
                <span>{{row.item.shop_code}}</span><br>
                <span>{{row.item.owner_name}}</span><br>
                <span>{{($THEME.packagePrefix) ? $THEME.packagePrefix[row.item.package] : row.item.package}}</span>
            </template>
            <template slot="image_front_area" slot-scope="row">
                <template v-if="row.item.image_front_area.length > 0">
                    <div v-for="(image_front_area , index) in row.item.image_front_area" :key="index">
                        <a class="a-tag color-tag" @click="showModalImages(image_front_area , `รูปพื้นที่หน้าร้าน ${index+1}`)">รูปพื้นที่หน้าร้าน {{index+1}}</a>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="image_environment_area" slot-scope="row">
                <template v-if="row.item.image_environment_area.length > 0">
                    <div v-for="(image_environment_area , index) in row.item.image_environment_area" :key="index">
                        <a class="a-tag color-tag" @click="showModalImages(image_environment_area , `รูปสภาพแวดล้อมหน้าร้าน ${index+1}`)">รูปสภาพแวดล้อมหน้าร้าน {{index+1}}</a>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="image_shop_area" slot-scope="row">
                <template v-if="row.item.image_shop_area.length > 0">
                    <div v-for="(image_shop_area , index) in row.item.image_shop_area" :key="index">
                        <a class="a-tag color-tag" @click="showModalImages(image_shop_area , `รูปพื้นที่ในร้าน ${index+1}`)">รูปพื้นที่ในร้าน {{index+1}}</a>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="image_storage_space" slot-scope="row">
                <template v-if="row.item.image_storage_space.length > 0">
                    <div v-for="(image_storage_space , index) in row.item.image_storage_space" :key="index">
                        <a class="a-tag color-tag" @click="showModalImages(image_storage_space , `รูปพื้นที่เก็บของ ${index+1}`)">รูปพื้นที่เก็บของ {{index+1}}</a>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="tier_shop" slot-scope="row">
                <div class="form-group">
                    <b-form-select 
                        :options="tierShop" 
                        v-model="row.item.tier_shop" 
                        class="form-control mx-4" 
                        @change="$emit('updateTierShop' , row.item.tier_shop , row.item.id)">
                        <template v-slot:first>
                            <option :value="null" disabled>{{'เลือก Tier'}}</option>
                        </template>
                    </b-form-select>
                </div>
            </template>
            <template slot="actions" slot-scope="row">
                <button
                    class="btn btn-sm btn-info px-3"
                    @click="$router.push({name:'branceedit',params:{Id:row.item.id}})"
                >แก้ไข</button>
                <button
                    class="btn btn-sm btn-danger px-3"
                    @click="($emit('showComfirmModal',row.item.id))"
                    v-if="auth0RoleUsage('brancemanagedelete')"
                >ลบ</button>
            </template>
        </b-table>
        <ModalImages :data="dataModalImages"></ModalImages>
    </div>
</template>
<script>
import ModalImages from '@/components/Modals/Modal-images'
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"TableBranceImages",
    props: {
        busy: Boolean,
        images: Array,
    },
    components:{
        ModalImages
    },
    data(){
        return {
            dataModalImages:{
                show:false,
                img:false,
                name:"img"
            },
            tierShop:[
                { value: "1", text: "Tier 1"},
                { value: "2", text: "Tier 2" },
                { value: "3", text: "Tier 3" },
                { value: "4", text: "Tier 4" }
            ],
            auth0RoleUsage: auth0RoleUsage,
        }
    },
    methods:{
        showModalImages( img , name ){
           this.dataModalImages.show = true
           this.dataModalImages.img = img
           this.dataModalImages.name = name
        },
    },
    computed:{
        fieldsImages(){
            let fields = [
                { key: "last_updated", label: "วันที่อัพเดตข้อมูลล่าสุด", sortable: true },
                { key: "shop_code", label: "ร้าน", sortable: true ,class: 'text-center'},
                { key: "image_front_area", label: "รูปพื้นที่หน้าร้าน", sortable: true ,class: 'text-center'},
                { key: "image_environment_area", label: "รูปสภาพแวดล้อมหน้าร้าน", sortable: true ,class: 'text-center'},
                { key: "image_shop_area", label: "รูปพื้นที่ในร้าน", sortable: true ,class: 'text-center'},
                { key: "image_storage_space", label: "รูปพื้นที่เก็บของ", sortable: true ,class: 'text-center'},
                { key: "tier_shop", label: "Tier ร้าน", sortable: true ,class: 'text-center'},
                { key: "actions", label: "การจัดการ", sortable: true }
            ]
            return fields
        },
    }
   
}
</script>